import React from "react"
import { Currency } from "../../util/numbers"
import { td, tdLabel } from "./constants"
import { PayoutDistribution } from "./types"

interface Props {
  distributions: PayoutDistribution[]
}

const DistributionTotalRow: React.FC<Props> = ({ distributions }) => {
  if (distributions.length === 0) return null

  const total = distributions.reduce((sum, dist) => sum + dist.amount, 0)

  return (
    <tbody className="border-t border-gray-400">
      <tr>
        <td className={tdLabel}>Total Payout Dist</td>
        <td className={td} />
        <td className={td} />
        <td className={td} />
        <td className={`${td} text-right font-bold text-red-600`}>{Currency(total)}</td>
      </tr>
    </tbody>
  )
}

export default DistributionTotalRow
